// extracted by mini-css-extract-plugin
module.exports = {"AbsoluteRow":"app_AbsoluteRow__afAHw"};